<template>
	<div class="link-auto-table" :class="classes" @mouseenter="lv_mouseenter" @mouseleave="lv_mouseleave">
		<div class="link-auto-table-title" v-if="!!option.title">{{ option.title }}</div>
		<div class="link-auto-table-content" :style="contentStyles">
			<link-auto-table-filter-form :show.sync="option.formFilterShow" :linkFilterOptions="option.linkFilterOptions" :width="option.formFilterWidth" @confirm="lv_formFiltersChange"/>
			<lnk-quickfilter v-if="!!option.lv_quickfilterOption" class="lnk-quickfilter" :options="option.lv_quickfilterOption" :type="option.quickfilterType" :default-value="option.quickfilterDefaultValue" @change="lv_quickFilterChange">
				<!--自定义快速筛选-->
				<slot name="customquickfilter"></slot>
			</lnk-quickfilter>
			<slot name="table-head"></slot>
			<div class="link-auto-table-header" v-if="!!option.showHeader">
				<div class="link-auto-table-header-left-side">
					<!--搜索栏-->
					<link-auto-table-search
						v-if="option.showFilterBar"
						ref="singleFilter"
						:autoOption="option"
						:link-filter-options="option.linkFilterOptions"
						:search-field.sync="option.searchField"
						:dynamicFilter="option.singleDynamicFilter"
						@change="lv_searchChange"
						:searchIcon="option.searchBarSearchIcon"
					/>
				</div>
				<!--操作按钮-->
				<div class="link-auto-table-header-button-wrapper">

					<!--正常状态-->
					<div v-show="status === EDIT_STATUS.NORMAL">
						<!--左插槽按钮-->
						<slot name="leftButton"></slot>
						<!--外部按钮-->
						<link-button v-for="(item,index) in buttons.outer"
									 :key="index"
									 :label="item.label"
									 @click="handleClickExternalButton(item)"
									 v-tooltip="{content:item.key,tooltip:true,placement:'top',arrow:true,}"
									 :disabled="item.lv_disabled()"
									 :availableTimes="item.availableTimes"
									 :synchronize="false"/>
						<!--右插槽按钮-->
						<slot name="button"></slot>
						<!--内部按钮-->
						<link-dropdown align="end" width="90px" :height="null" hide-scrollbar v-if="option.showMoreButton" fit-height disabledDestroyOnHide :showArrow="false" :offset="4">
							<link-button slot="reference" icon="link-icon-down" icon-position="right">{{ $t('global.more') }}</link-button>
							<div slot="popover" class="link-auto-table-more-button-dropdown">
								<link-dropdown-item v-for="(item,index) in buttons.inner"
													v-tooltip="{content:item.key,tooltip:true,placement:'left',arrow:true,}"
													:key="index"
													@click="handleClickExternalButton(item)"
													:label="item.label"
													:disabled="item.lv_disabled()"
													:availableTimes="item.availableTimes"/>
							</div>
						</link-dropdown>
					</div>
					<!--新建或者编辑状态-->
					<div v-show="status !== EDIT_STATUS.NORMAL && status !== EDIT_STATUS.SELECT" class="link-auto-table-button-group">
						<link-button :label="$t('LinkAutoTable.saveAndCreate')" @click="lv_saveAndCreated" v-if="!!option.saveAndCreateButton && status === EDIT_STATUS.INSERT"
									 v-tooltip="{content:'Ctrl+Shift+N',tooltip:true,placement:'top',arrow:true,}" :synchronize="false"/>
						<link-button :label="$t('LinkAutoTable.continueCreate')" @click="lv_create()" v-if="!!option.batchInsertable && status === EDIT_STATUS.INSERT"
									 v-tooltip="{content:'Ctrl+N',tooltip:true,placement:'top',arrow:true,}" :synchronize="false"/>
						<link-button :label="$t('global.cancel')" @click="lv_cancel" type="line" v-tooltip="{content:'Ctrl+U',tooltip:true,placement:'top',arrow:true,}" :synchronize="false"/>
						<link-button :label="$t('global.save')" @click="lv_save" v-tooltip="{content:'Ctrl+S',tooltip:true,placement:'top',arrow:true,}" :synchronize="false"/>
					</div>
					<!--选择状态-->
					<div v-show="status === EDIT_STATUS.SELECT">
						<link-button :label="$t('global.cancel')" @click="lv_cancelSelect" type="line"/>
						<link-button :label="$t('global.confirm')" @click="lv_confirmSelect"/>
					</div>
				</div>
			</div>
			<link-auto-table-filter-tag
				@change="lv_filterTagChange"
				:filter-results="option.combineFilter.filterResults"
				:filter-options="option.combineFilter.filterOptions"
				:filter-operator="option.combineFilter.filterOperator"
				:column-params="option.columnParams"
			/>
			<div class="link-auto-table-body">

				<link-table
					v-if="!!option"
					ref="baseTable"

					:row-num="option.rowNum"
					:data="list"
					:sort-field="option.sortField"
					:sort-desc="option.sortDesc"
					:row-height="option.bodyRowHeight"
					:multi-select="!option.singleSelect"
					:select-index="option.selectIndex"
					:configColumnFunc="p_configColumnFunc"
					:beforeConfigColumnFunc="p_beforeConfigColumnFunc"
					:default-enable-editable="option.defaultEnableEditable"
					:fast-render="option.fastRender"
					:fixed-row-data="option.fixedRowData"
					:showEmptyText="!option.loading"
					:column-filter="option.columnFilter"
					:disabled-body-scroll="option.disabledBodyScroll"
					:disabledSelect="status !== EDIT_STATUS.NORMAL"
					:editableFunc="option.editableFunc"
					:requiredFunc="option.requiredFunc"

					@collect="lv_collect"
					@rowClick="lv_click"
					@rowDblClick="lv_dblClick"
					@vertical-scroll-bottom="option._loadDataChunk()"
					@clickTitle="lv_showSortFilterDialog"
				>
					<link-table-column-index v-if="option.indexing" :page="option.pageData.showPage" :page-size="option.pageData.pageSize" :fixedRowText="option.fixedRowText"/>
					<link-table-column-check v-if="status === EDIT_STATUS.SELECT || !option.singleSelect"
											 :select-cache="status === EDIT_STATUS.SELECT || option.selectCache"
											 :single-select="!(status === EDIT_STATUS.SELECT || !option.singleSelect)"
											 :beforeCheck="option.beforeCheck"
											 :before-uncheck="option.beforeUncheck"
											 :toggleOnClickRow="option.checkOnClickRow"
											 ref="check"/>
					<slot></slot>
					<link-rendering-render-func v-if="!!option.render" :render-func="option.render"/>
				</link-table>
			</div>
			<div class="link-auto-table-footer" v-if="!!option.showFooter" :class="{'link-auto-table-footer-nodata':!(!!option.list && option.list.length>0)}">
				<link-pagebar
					:page="option.pageData.page"
					:pageSize="option.pageData.pageSize"
					:show-page-num="option.showPageNum"
					:size-option="option.sizeOption"
					:totalSize="option.pageData.total"
					:availablePage="option.availablePageNum"

					@sizeChange="e=>{option.pageData.pageSize = e;option.reload()}"
					@jumpPage="option.jumpPage"
					@prevPage="option.prevPage"
					@nextPage="option.nextPage"/>

				<div class="link-auto-table-footer-total-count-wrapper" v-if="option.showPageCount" @click="!!option && (option._requestTotalCount())">
					{{ $t('LinkAutoTable.currentPage') }}
					<span v-if="option.list.length>0">{{ (option.pageData.page - 1) * option.pageData.pageSize + 1 }}-{{ (option.pageData.page) * option.pageData.pageSize }}</span>
					<span v-else>0-0</span>
					，
					{{ $t('LinkAutoTable.total') }} <span class="link-auto-table-footer-total-count-num">{{ option.pageData.total + (option.pageData.noMore ? 0 : -1) + (!option.pageData.noMore ? '+' : '') }}</span> {{ $t('LinkAutoTable.records') }}
				</div>
			</div>
			<link-loading-shadow :value="!!option && (option.loading)">
				<!--            <link-loading-shadow :value="true">-->
				<link-button shape="round" :label="$t('LinkAutoTable.cancelQuery')" @click="option.cancelQueryPageRequest()" v-if="option.cancelable"/>
			</link-loading-shadow>
		</div>
	</div>
</template>

<script>
import LnkExportPick from '../../components/lnk-export-pick/lnk-export-pick';
import LinkAutoTableFilter from './link-auto-table-filter';
import LinkRenderingRenderFunc from '../render/link-rendering-render-func';
import LinkAutoTableFilterTag from './link-auto-table-filter-tag';
import {AutoTableController, EDIT_STATUS} from './index';
import tooltip from '../tooltip';
import LinkAutoTableFilterForm from "./link-auto-table-filter-form";
import {AutoTableFilter} from "./auto-table-filter";
import {getIdService} from "../id.service";

export default {
	name: 'link-auto-table',
	directives: {tooltip},
	components: {
		LinkAutoTableFilterForm,
		LinkAutoTableFilterTag,
		LinkRenderingRenderFunc,
		LinkAutoTableFilter,
		LnkExportPick
	},
	props: {option: {type: Object, require: true}},
	data() {
		return {
			alwaysUpdateFields: ['id', 'corpid'],
			renderColumns: null,
			baseTable: null,
			status: EDIT_STATUS.NORMAL,
			newData: [],
			EDIT_STATUS,
			/*选择缓存变量*/
			p_selectData: {
				autoCancelSelectStatus: null,           //临时变量：是否自动取消选择状态
				onConfirm: null,
				onCancel: null
			},
			standardButtons: {
				insert: {
					type: 'insert',
					label: LinkVue.$t('LinkAutoTable.insertButton'),
					handler: () => this.lv_create(),
					key: 'Ctrl+N'
				},
				copy: {
					type: 'insert',
					label: LinkVue.$t('LinkAutoTable.copyButton'),
					handler: () => this.lv_copy(),
					key: 'Ctrl+B'
				},
				delete: {
					type: 'delete',
					label: LinkVue.$t('LinkAutoTable.deleteButton'),
					handler: () => this.lv_delete(),
					key: 'Ctrl+D'
				},
				importOut: {
					type: 'import',
					label: LinkVue.$t('LinkAutoTable.importButton'),
					handler: () => this.importData()
				},
				batchInsert: {
					type: 'insert',
					inner: true,
					label: LinkVue.$t('LinkAutoTable.batchInsertButton'),
					handler: () => this.lv_batchInsert(),
				},
				batchUpdate: {
					type: 'update',
					inner: true,
					label: LinkVue.$t('LinkAutoTable.batchUpdateButton'),
					handler: () => this.lv_batchUpdate()
				},
				combineSearch: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.combineSearchButton'),
					handler: () => this.option.showFilter(),
					key: 'Ctrl+G'
				},
				combineMangerSearch: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.combineSearchMangerButton'),
					handler: () => this.option.gotoFilterMangerPage()
				},
				import: {
					type: 'import',
					inner: true,
					label: LinkVue.$t('LinkAutoTable.importButton'),
					handler: () => this.importData()
				},
				export: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.exportButton'),
					handler: () => this.exportData()
				},
				showCounts: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.showCountButton'),
					handler: () => this.showCounts(),
					key: 'Ctrl+Shift+3'
				},
				showRecordDetail: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.showRecordDetailButton'),
					handler: () => this.showRecordDetail(),
					key: 'Ctrl+Alt+K'
				},
				showModifyHistory: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.showModifyHistoryButton'),
					handler: () => this.showModifyHistory(),
					key: 'Ctrl+H'
				},
				showTableConfig: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.showTableConfigButton'),
					handler: () => this.showTableConfig()
					// key: 'Ctrl+H',
				},
				showMoreRows: {
					inner: true,
					label: LinkVue.$t('LinkAutoTable.showMoreRowsButton'),
					handler: () => this.showMoreRows(),
					availableTimes: 1
					// key: 'Ctrl+H',
				},
				batchModify: {
					inner: true,
					type: 'update',
					label: LinkVue.$t('LinkAutoTable.batchModifyButton'),
					handler: () => this.lv_batchModify(),
					key: 'Ctrl+M'
				},
				formEdit: {
					inner: true,
					type: 'update',
					label: LinkVue.$t('LinkAutoTable.forEditButton'),
					handler: () => this.lv_openFormEdit(),
					key: 'Ctrl+I'
				},
				clearCache: {
					inner: true,
					type: 'other',
					label: LinkVue.$t('LinkAutoTable.clearCache'),
					handler: () => this.lv_clearCache(),
				},
			},
			keyboardListeners: {
				/*@formatter:off*/
                    /*取消*/
                    'ctrl+u': () => {this.lv_cancel();},
                    /*刪除*/
                    'ctrl+d': () => {Boolean(this.option.lv_enable.deleteable) && Boolean(this.option.deleteButton) && !this.standardButtons.delete.lv_disabled() && this.lv_delete();},
                    /*新建*/
                    'ctrl+n': () => {Boolean(this.option.lv_enable.insertable) && Boolean(this.option.insertButton) && !this.standardButtons.insert.lv_disabled() &&  this.lv_create();},
                    /*继续新建*/
                    'ctrl+shift+n': () => {this.lv_saveAndCreated();},
                    /*复制*/
                    'ctrl+b': () => {Boolean(this.option.lv_enable.insertable) && Boolean(this.option.copyButton) && !this.standardButtons.copy.lv_disabled() &&  this.lv_copy();},
                    /*保存*/
                    'ctrl+s': () => {this.lv_save();},
                    /*组合查询*/
                    'ctrl+g': () => {Boolean(this.option.combineSearchButton) && this.option.showFilter();},
                    /*记录详情*/
                    'ctrl+alt+k': () => {Boolean(this.option.showRecordDetailButton) && this.showRecordDetail();},
                    /*记录计数*/
                    'ctrl+shift+3': () => {Boolean(this.option.showCountsButton) && this.showCounts();},
                    /*全选*/
                    'ctrl+a': () => {
                        if (!this.option.singleSelect) {
                            this.selectAll();
                        } else return true;
                    },
                    /*保存*/
                    enter: () => {this.lv_save();},
                    /*修改历史*/
                    'ctrl+h': () => {Boolean(this.option.tableCode) && this.showModifyHistory();},
                    /*批量修改*/
                    'ctrl+m': () => {Boolean(this.option.batchModifyButton) && Boolean(this.option.lv_enable.updateable) &&  this.lv_batchModify();},
                    /*表单编辑*/
                    'ctrl+i': () => {Boolean(this.option.formEditButton) && Boolean(this.option.lv_enable.updateable) && this.lv_openFormEdit();},
                    /*上一页*/
                    left: () => {this.lv_left();},
                    /*下一页*/
                    right: () => {this.lv_right();},
                    /*上一条*/
                    up: () => {this.lv_up();},
                    /*下一条*/
                    down: () => {this.lv_down();}
                    /*@formatter:on*/
			}
		};
	},
	created() {
		AutoTableController.add(this);
		if (Boolean(this.option)) {
			this.option._loadDefaultOption('auto-table');
		}

	},
	beforeDestroy() {
		AutoTableController.remove(this);
		this.$lv.$utils.keyboard.removeListener(this.keyboardListeners);
	},
	mounted() {
		this.baseTable = this.$refs.baseTable;
	},
	computed: {
		classes() {
			return [{'link-auto-table-fill': Boolean(this.option) && Boolean(this.option.fill)}];
		},
		list() {
			return this.option.list;
		},
		buttons() {
			/*默认类型排序大小*/
			const buttonDefaultSort = {insert: 100, update: 50, delete: 10, other: 1};
			/*结果*/
			const ret = {inner: [], outer: []};
			/*缓存数组*/
			const buttons = [...this.option.buttons || []];
			/*判断是否添加标准按钮*/
			Boolean(this.option.insertButton) && buttons.push(this.standardButtons.insert) && (this.standardButtons.insert.disabled = this.option.standardButtonDisabled.insertButton);
			Boolean(this.option.copyButton) && Boolean(this.option.copyable) && buttons.push(this.standardButtons.copy) && (this.standardButtons.copy.disabled = this.option.standardButtonDisabled.copyButton);
			Boolean(this.option.deleteButton) && buttons.push(this.standardButtons.delete) && (this.standardButtons.delete.disabled = this.option.standardButtonDisabled.deleteButton);
			Boolean(this.option.importButton) && buttons.push(this.standardButtons.importOut) && (this.standardButtons.importOut.disabled = this.option.standardButtonDisabled.importButton);
			Boolean(this.option.batchUpdateable) && buttons.push(this.standardButtons.batchUpdate) && (this.standardButtons.batchUpdate.disabled = this.option.standardButtonDisabled.batchUpdateable);
			Boolean(this.option.batchInsertable) && this.option.batchInsertButton !== false && buttons.push(this.standardButtons.batchInsert) && (this.standardButtons.batchInsert.disabled = this.option.standardButtonDisabled.batchInsertable);
			Boolean(this.option.combineSearchButton) && buttons.push(this.standardButtons.combineSearch) && (this.standardButtons.combineSearch.disabled = this.option.standardButtonDisabled.combineSearchButton);
			Boolean(this.option.combineSearchButton) && buttons.push(this.standardButtons.combineMangerSearch) && (this.standardButtons.combineMangerSearch.disabled = this.option.standardButtonDisabled.combineSearchButton);
			Boolean(this.option.settingButton) && buttons.push(this.standardButtons.showTableConfig) && (this.standardButtons.showTableConfig.disabled = this.option.standardButtonDisabled.settingButton);
			Boolean(this.option.exportable) && buttons.push(this.standardButtons.export);
			Boolean(this.option.importable) && buttons.push(this.standardButtons.import);
			Boolean(this.option.showMoreRowsButton) && buttons.push(this.standardButtons.showMoreRows) && (this.standardButtons.showMoreRows.disabled = this.option.standardButtonDisabled.showMoreRowsButton);
			Boolean(this.option.showCountsButton) && buttons.push(this.standardButtons.showCounts) && (this.standardButtons.showCounts.disabled = this.option.standardButtonDisabled.showCountsButton);
			Boolean(this.option.showRecordDetailButton) && buttons.push(this.standardButtons.showRecordDetail) && (this.standardButtons.showRecordDetail.disabled = this.option.standardButtonDisabled.showRecordDetailButton);
			Boolean(this.option.showClearCacheButton) && buttons.push(this.standardButtons.clearCache)
			Boolean(this.option.lv_enable.updateable) && Boolean(this.option.batchModifyButton) && buttons.push(this.standardButtons.batchModify) && (this.standardButtons.batchModify.disabled = this.option.standardButtonDisabled.batchModifyButton);
			Boolean(this.option.lv_enable.updateable) && Boolean(this.option.formEditButton) && buttons.push(this.standardButtons.formEdit) && (this.standardButtons.formEdit.disabled = this.option.standardButtonDisabled.formEditButton);
			if (this.option.tableCode) buttons.push(this.standardButtons.showModifyHistory);
			/*设置默认类型以及排序*/
			buttons.forEach((btn) => {
				btn.type = btn.type || 'other';
				btn.order = btn.order != null ? btn.order : buttonDefaultSort[btn.type];
				this.$set(btn, 'disabled', btn.disabled || false);
				this.$set(btn, 'availableTimes', btn.availableTimes || null);
			});
			/*对按钮数据进行插入排序*/
			this.$lv.$utils.insertSort(buttons, (a, b) => b.order > a.order);
			/*对按钮进行内外分组*/
			buttons.forEach((btn) => {
				if (btn.type === 'insert' && !this.option.lv_enable.insertable) return;
				if (btn.type === 'update' && !this.option.lv_enable.updateable) return;
				if (btn.type === 'delete' && !this.option.lv_enable.deleteable) return;
				if (btn.type === 'other' && !this.option.lv_enable.otherable) return;
				if (!btn.lv_disabled) {
					btn.lv_disabled = () => {

						if (btn.type === 'insert' && this.option.lv_disabled.insertable) return true;
						if (btn.type === 'update' && this.option.lv_disabled.updateable) return true;
						if (btn.type === 'delete' && this.option.lv_disabled.deleteable) return true;
						if (btn.type === 'other' && this.option.lv_disabled.otherable) return true;

						if (!!this.option.parentOption && this.option.parentOption.hasParentEditing() && btn.type !== 'other') return true
						return this.$lv.$utils.typeOf(btn.disabled) === 'function' ? btn.disabled.apply(this.option.context) : Boolean(btn.disabled);
					};
				}
				ret[Boolean(btn.inner) ? 'inner' : 'outer'].push(btn);
			});
			return ret;
		},
		contentStyles() {
			if (!((Boolean(this.option) && Boolean(this.option.fill)))) {
				return {}
			} else return {
				height: `calc(100% - ${!!this.option.title ? '50' : '0'}px)`
			}
		},
	},
	methods: {
		/*可用函数*/

		/**
		 * 重新加载当前页数据
		 * @author  韦胜健
		 * @date    2019/1/9 18:35
		 */
		async load() {
			await this.$lv.$utils.delay(0);
			return await this.lv_optionLoad();
		},
		/**
		 * 从第一页开始，从新请求数据
		 * @author  韦胜健
		 * @date    2019/1/9 18:36
		 */
		async reload() {
			await this.$lv.$utils.delay(0);
			return await this.lv_optionLoad(true);
		},
		/**
		 * 刷新列
		 * @author  韦胜健
		 * @date    2019/1/12 11:16
		 */
		refreshRender() {
			this.$refs.baseTable.refreshRender();
		},
		/**
		 * option.singleSelect为true时，改方法可获取选中的行
		 * @author  韦胜健
		 * @date    2019/1/12 11:18
		 */
		getSelected() {
			return Boolean(this.option.singleSelect) ? this.lv_getRow() : this.$refs.check.getSelectedRows();
		},
		/**
		 * 选中所有行，多选模式下才能看到效果
		 * @author  韦胜健
		 * @date    2019/1/12 11:19
		 */
		selectAll() {
			Boolean(this.$refs.check) && this.$refs.check.selectAll();
		},
		/**
		 * 取消选中所有行
		 * @author  韦胜健
		 * @date    2019/1/12 11:20
		 */
		unselectAll() {
			Boolean(this.$refs.check) && this.$refs.check.clearSelected();
		},
		/**
		 * 清除单字段搜索关键字
		 * @author  韦胜健
		 * @date    2019/1/18 10:10
		 */
		clearSearchValue() {
			!!this.option.singleDynamicFilter && this.option.singleDynamicFilter.clearValue()
		},
		/**
		 * 修改状态
		 * @author  韦胜健
		 * @date    2019/8/14 14:26
		 */
		changeStatus(status) {
			if (!this.EDIT_STATUS[status]) {
				throw new Error(`状态[${status}]不存在！`)
			}
			this.status = status
			this.option._onTableStatusChange(this.status)
		},
		/**
		 * 修改选中行
		 * @author  韦胜健
		 * @date    2019/8/14 14:38
		 */
		async changeSelectRow(index) {
			this.option.selectIndex = null
			await this.$lv.nextTick()
			this.option.selectIndex = index
			this.option._onTableSelectChange(index)
		},

		/**
		 * 开启选择状态，获取选择的数据
		 * @author  韦胜健
		 * @date    2019/3/26 15:34
		 * @param   autoCancelSelectStatus      是否自动取消选择状态
		 * @param   onConfirm                   选择确认触发动作
		 * @param   onCancel                    选择取消触发动作
		 */
		async select({autoCancelSelectStatus = true, onConfirm, onCancel}) {
			this.changeStatus(this.EDIT_STATUS.SELECT)
			if (!this.option.singleSelect) await this.$lv.nextTick();
			this.refreshRender();
			Object.assign(this.p_selectData, {autoCancelSelectStatus, onConfirm, onCancel});
		},
		/**
		 * 自定义新建数据，往数据中列表添加一条数据
		 * @author  韦胜健
		 * @date    2019/2/25 15:59
		 */
		/**
		 * 取消选择状态
		 * @author  韦胜健
		 * @date    2019/6/12 18:07
		 */
		async cancelSelect() {
			return await this.lv_cancelSelect()
		},
		/**
		 * 开启表单编辑当前选中行
		 * @author  韦胜健
		 * @date    2019/6/12 18:08
		 */
		async openFormEdit() {
			return await this.lv_openFormEdit()
		},
		/**
		 * 开启批量修改动作
		 * @author  韦胜健
		 * @date    2019/6/12 18:09
		 */
		async openBatchModify() {
			return await this.lv_batchModify()
		},
		/**
		 * 插入自定义数据
		 * @author  韦胜健
		 * @date    2019/10/25 16:05
		 * @param   row                 object|array    要插入的自定义数据
		 * @param   saved               boolean         是否自动保存(自动保存不会发送请求，只是该行状态处于已保存的状态)
		 * @return  Promise<void>
		 */
		async insertCustomData(row, saved = true) {
			const rows = this.$lv.$utils.typeOf(row) === 'array' ? row : [row]
			if (saved) {
				this.list.unshift(...rows);
				this.changeSelectRow(0)
			} else {
				for (let i = 0; i < rows.length; i++) {
					const r = rows[i];
					await this.lv_create({...r})
				}
			}
		},
		/**
		 * 自定义更新数据，往将数据列表中一条数据更新
		 * @author  韦胜健
		 * @date    2019/2/25 15:59
		 * @param   newRow                  object  新行数据
		 * @param   rowIndex                number  旧行索引
		 * @return  void
		 */
		async updateCustomData(newRow, rowIndex) {
			const {row, editRow} = this.baseTable.p_tableData[rowIndex]
			this.baseTable.saveEdit([{row, editRow, newRow}]);
		},
		/**
		 * 自定义删除数据，删除数据列表中的一条数据
		 * @author  韦胜健
		 * @date    2019/2/25 16:00
		 * @param   rowIndex                要删除的数据索引
		 */
		async deleteCustomData(rowIndex) {
			this.list.splice(rowIndex, 1);
			if (this.list.length > 0) {
				this.changeSelectRow(rowIndex)
			} else {
				this.changeSelectRow(null)
			}
		},

		/*工具函数*/

		/**
		 * 检查当前状态，根据不同状态触发不同动作
		 * @author  韦胜健
		 * @date    2019/1/9 16:28
		 */
		async lv_checkStatus({insert, update, normal, select, final}) {
			// console.log(this.status)
			switch (this.status) {
				case this.EDIT_STATUS.NORMAL:
					Boolean(normal) && await normal.apply(this);
					break;
				case this.EDIT_STATUS.INSERT:
					Boolean(insert) && await insert.apply(this);
					break;
				case this.EDIT_STATUS.UPDATE:
					Boolean(update) && await update.apply(this);
					break;
				case this.EDIT_STATUS.SELECT:
					Boolean(select) && await select.apply(this);
					break;
			}
			Boolean(final) && await final.apply(this);
		},

		/*处理动作*/

		async lv_initOption() {
			await this.$lv.$utils.delay(0)
			if (!this.option || this.option.tableCreated) return;
			this.option.tableCreated = true;
			/*如果不需要自动填满父元素，直接请求数据*/
			if (!this.option.fill) this.option.loadOnStart && this.option.reload();
			else {
				/*如果需要填满父元素高度，并且自动设置显示行数，这里计算需要显示的行数，再去查询数据*/
				await this.$lv.nextTick();
				const bodyTotalHeight = this.baseTable.$refs.body.$el.clientHeight;
				// console.log({bodyTotalHeight,autoTableHeight:this.$el.clientHeight})

				this.option.fillRows = Math.floor(bodyTotalHeight / this.option.bodyRowHeight);
				// let fillRows = ((Math.floor(this.option.fillRows / 5)) * 5)
				// console.log(fillRows, fillRows * this.option.bodyRowHeight, bodyTotalHeight)
				// if (fillRows * this.option.bodyRowHeight > bodyTotalHeight) fillRows -= 5
				// console.log(fillRows)
				this.option.fillRows = this.option.fillRows < 5 ? 5 : this.option.fillRows;
				this.$set(this.option.param, 'rows', this.option.fillRows);
				if (!this.option.sizeOption.some((item) => item === this.option.fillRows)) this.option.sizeOption.unshift(this.option.fillRows);
				this.option.loadOnStart && this.option.reload();
			}
		},
		async lv_formFiltersChange(dynamicFilterList) {
			this.option.formDynamicFilterList = dynamicFilterList.map(item => item.copy())
			this.reload()
		},

		/**
		 * 列表列数据收集完毕
		 * @author  韦胜健
		 * @date    2019/1/9 17:17
		 */
		lv_collect(columns) {

			this.renderColumns = columns;
			this.$emit('collect', this.renderColumns)

			const searchField = this.option.searchField
			let quickfilterOptions = []
			let lnkFilterOptions = []
			let linkFilterOptions = []
			let hasLastUpdated, hasCreated;                                     /*判断是否存在创建时间以及更新时间字段*/

			/*获取通用筛选参数以及组合查询所需要的查询参数*/
			[...columns, ...(this.option.externalFilterColumns || [])].forEach((column) => {
				/*如果列不能搜索或者列隐藏，则不能进行筛选*/
				if (column.field === 'lastUpdated') hasLastUpdated = true
				if (column.field === 'created') hasCreated = true
				lnkFilterOptions.push(AutoTableFilter.getLnkFilterOption(column, searchField))
				linkFilterOptions.push(AutoTableFilter.getLinkFilterOption(column))
				quickfilterOptions.push(AutoTableFilter.getQuickFilterOption(column))
			});

			/*没有创建时间或者更新时间字段，则自动加上创建时间以及更新时间字段*/
			if (!hasCreated) {
				const createdColumn = {title: '创建时间', field: 'created', filterName: 'date',}
				lnkFilterOptions.push(AutoTableFilter.getLnkFilterOption(createdColumn, searchField))
				linkFilterOptions.push(AutoTableFilter.getLinkFilterOption(createdColumn))
			}
			if (!hasLastUpdated) {
				const lastUpdatedColumn = {title: '更新时间', field: 'lastUpdated', filterName: 'date',}
				lnkFilterOptions.push(AutoTableFilter.getLnkFilterOption(lastUpdatedColumn, searchField))
				linkFilterOptions.push(AutoTableFilter.getLinkFilterOption(lastUpdatedColumn))
			}

			this.option.combineFilter.filterOptions = lnkFilterOptions.filter(item => !!item)
			this.option.quickfilterOptions = quickfilterOptions.filter(item => !!item)
			this.option.linkFilterOptions = linkFilterOptions.filter(item => !!item)
		},
		/**
		 * 鼠标进入表格
		 * @author  韦胜健
		 * @date    2019/1/9 17:08
		 */
		lv_mouseenter() {
			this.$lv.$utils.keyboard.addListener(this.keyboardListeners);

		},
		/**
		 * 鼠标离开表格
		 * @author  韦胜健
		 * @date    2019/1/9 17:08
		 */
		lv_mouseleave() {
			this.$lv.$utils.keyboard.removeListener(this.keyboardListeners);
		},
		/**
		 * 排序变化事件
		 * @author  韦胜健
		 * @date    2019/1/9 18:33
		 */
		lv_sortChange({row, field, desc}) {
			if (this.status !== this.EDIT_STATUS.SELECT) this.lv_cancel();
			this.option.param.sort = field;
			this.option.param.order = desc ? 'desc' : 'asc';
			this.option.reload();
		},
		/**
		 * 筛选参数变化事件
		 * @author  韦胜健
		 * @date    2019/1/9 18:33
		 */
		lv_searchChange(dynamicFilter) {
			this.option.singleDynamicFilter = dynamicFilter
			this.lv_optionLoad(true);
		},
		/**
		 * 打开筛选排序对话框
		 * @author  韦胜健
		 * @date    2019/9/26 14:44
		 */
		lv_showSortFilterDialog({col}) {
			if ((!col.search && !col.sort && !col.columnFilter) || !!col.hide || !!this.option.disabledColumnFilter) return
			this.$lv.$sortFilterDialog.show({
				option: this.option,
				col,
				onConfirm: ({linkSelectFilterData, searchDynamicFilter, sortValue}) => {
					/*link-auto-table-filter-tag没有深度监听columnParams，只能用这种方式设置新的筛选参数，如果直接将searchDynamicFilter设置入columnParam，
					* 那么在响应式初始化这个对象的时候，object列筛选的column以及externalData中的autoOption会导致死循环*/
					const columnParam = {}
					this.option.columnParams = {...this.option.columnParams, [col.field]: columnParam}
					Object.assign(columnParam, col.field, {
						searchDynamicFilter,
						linkSelectFilterData,
						field: col.field,
						title: col.title,
					})

					if (!!sortValue) {
						this.option.sortField = col.field
						this.option.sortDesc = sortValue === 'desc'
					} else {
						this.option.sortField = this.option._initOption.sortField || AutoOption.getDefaultPublicOption().sortField
						this.option.sortDesc = this.option._initOption.sortDesc == null ? true : this.option._initOption.sortDesc
					}
					this.option.reload()
				}
			})
		},
		/**
		 * 快速筛选变化
		 * @author  韦胜健
		 * @date    2019/4/2 19:07
		 */
		lv_quickFilterChange(e) {
			this.option.quickfilterValue = e;
			this.lv_optionLoad(true);
		},
		/**
		 * 重新加载数据
		 * @author  韦胜健
		 * @date    2019/4/2 19:08
		 */
		async lv_optionLoad(isReload) {
			return Boolean(isReload) ? await this.option.reload() : await this.option.load();
		},
		/**
		 * 双击动作处理
		 * @author  韦胜健
		 * @date    2019/1/9 16:29
		 */
		async lv_dblClick({row, rowIndex}) {
			if (!!this.option.disabledDblClick) return
			this.$emit('dblClick', {row, rowIndex});
			if (!!this.option.parentOption && this.option.parentOption.hasParentEditing()) return
			if (row.lv_editing) return
			this.lv_checkStatus({
				async insert() {
					await this.lv_save();
					this.lv_update(rowIndex);
				},
				async update() {
					if (row.lv_editing) return;
					await this.lv_save();
					this.lv_update(rowIndex);
				},
				normal() {
					if (Boolean(this.option.lv_enable.updateable)) {
						this.lv_update(rowIndex);
					}
				},
				final() {
					this.option._dblclick({row, rowIndex});
				}
			});
		},
		/**
		 * 单击行动作处理
		 * @author  韦胜健
		 * @date    2019/1/9 17:16
		 */
		async lv_click({row, rowIndex}) {
			row = this.list[rowIndex];
			this.lv_checkStatus({
				normal() {
					if (rowIndex === this.option.selectIndex) return;
					this.changeSelectRow(rowIndex)
					this.$emit('click', {row, rowIndex});
				}
			});
		},
		/**
		 * 选择上一条数据
		 * @author  韦胜健
		 * @date    2019/4/8 20:48
		 */
		lv_up() {
			if (this.option.list.length === 0 || this.option.selectIndex === 0) return;
			this.lv_click({rowIndex: this.option.selectIndex - 1});
		},
		/**
		 * 选择下一条数据
		 * @author  韦胜健
		 * @date    2019/4/8 20:49
		 */
		lv_down() {
			if (this.option.list.length === 0 || this.option.selectIndex === this.option.list.length - 1) return;
			this.lv_click({rowIndex: this.option.selectIndex + 1});
		},
		/**
		 * 上一页
		 * @author  韦胜健
		 * @date    2019/4/8 20:49
		 */
		lv_left() {
			this.lv_checkStatus({normal: () => this.option.prevPage()});
		},
		/**
		 * 下一页
		 * @author  韦胜健
		 * @date    2019/4/8 20:49
		 */
		lv_right() {
			this.lv_checkStatus({normal: () => this.option.nextPage()});
		},
		/**
		 * 取消编辑
		 * @author  韦胜健
		 * @date    2019/1/9 17:16
		 */
		lv_cancel() {
			if (this.status === this.EDIT_STATUS.NORMAL) return;
			this.lv_checkStatus({
				insert() {
					this.option.selectIndex -= this.newData.length;
					this.list.splice(0, this.newData.length);
					this.newData.splice(0, this.newData.length);
				},
				update() {
					this.baseTable.cancelEdit();
				},
				select() {
					this.lv_cancelSelect();
				},
				async final() {
					!!this.option.beforeCancel && (await this.option.beforeCancel.apply(this.option.context, [this.status]))
					this.changeStatus(this.EDIT_STATUS.NORMAL)
				}
			});
		},
		/**
		 * 保存编辑
		 * @author  韦胜健
		 * @date    2019/1/9 17:16
		 */
		async lv_save() {
			if (this.status === this.EDIT_STATUS.NORMAL) return;
			if (this.status === this.EDIT_STATUS.SELECT) {
				this.lv_confirmSelect();
				return;
			}

			const that = this;
			const {flag, validateMsg, col} = this.baseTable.validate();
			// console.log({flag, validateMsg, col})
			if (!flag) {
				this.$dialog.show(`${col.title}${validateMsg}`);
				return Promise.reject(`${col.title}${validateMsg}`);
			}

			return new Promise((rs) => {
				const editData = this.baseTable.getEdit();
				this.lv_checkStatus({
					async insert() {
						const {row, editRow} = editData[0];
						if (editData.length === 1) {
							await this.optionInsert(row, editRow);
						} else {
							await this.optionBatchInsert(editData);
						}
						that.baseTable.disableEdit();
						this.changeStatus(this.EDIT_STATUS.NORMAL)
						this.newData.splice(0, this.newData.length);
						rs();
					},
					async update() {
						const {row, editRow} = editData[0];
						if (editData.length === 1) {
							await this.optionUpdate(row, editRow);
						} else {
							await this.optionBatchUpdate(editData);
						}
						that.baseTable.disableEdit();
						this.changeStatus(this.EDIT_STATUS.NORMAL)
						rs();
					}
				});
			});
		},

		/*extension*/

		/**
		 * 点击复制按钮
		 * @author  韦胜健
		 * @date    2019/1/12 11:46
		 */
		async lv_copy() {
			if ((!this.option.lv_enable.insertable || !this.option.copyable) && Boolean(this.option.copyButton)) return;

			const newRow = this.$lv.$utils.deepCopy(this.lv_getRow());
			const excludeKeys = this.option.copyExcludeKey;
			excludeKeys.forEach((key) => newRow[key] = null);
			Boolean(this.option.copyRowFormatter) && this.option.copyRowFormatter.apply(this.option.context, [newRow]);
			this.lv_create(newRow);
		},
		/**
		 * 点击新建按钮
		 * @author  韦胜健
		 * @date    2019/1/9 17:43
		 */
		async lv_create(newRow = {}) {
			if (!this.option.lv_enable.insertable && Boolean(this.option.insertButton)) return;
			Boolean(this.option.beforeEnableCreate) && await this.option.beforeEnableCreate.call(this.option.context, []);

			const next = async () => {

				/*获取新行数据*/
				const defaultNewRow = await this.option._defaultNewRow();
				newRow = Object.assign({}, defaultNewRow, newRow);
				Object.keys(newRow).forEach((key) => this.$set(newRow, key, newRow[key]));
				this.renderColumns.forEach((column) => Boolean(column.field) && this.$set(newRow, column.field, newRow[column.field]));
				if (this.option.defaultId) {
					const $idService = getIdService(this)
					this.option.loading = true;
					this.$set(newRow, 'id', await $idService.newId());
					this.option.loading = false;
				}

				switch (this.option.editType) {
					case 'inline':
						this.newData.unshift(newRow);
						this.list.unshift(newRow);
						this.$nextTick(() => {
							this.baseTable.enableEdit(0);
							this.changeSelectRow(this.option.selectIndex == null ? 0 : this.option.selectIndex + 1)
						});
						break;
					case 'form':
						this.lv_formEdit(newRow, this.$lv.$utils.deepCopy(newRow));
						break;
				}
				this.changeStatus(this.EDIT_STATUS.INSERT)
			};

			await this.lv_checkStatus({
				async insert() {
					Boolean(this.option.batchInsertable) && await next();
				},
				async normal() {
					await next();
				}
			});
		},
		/**
		 * 继续新建
		 * @author  韦胜健
		 * @date    2019/4/3 17:14
		 */
		lv_saveAndCreated() {
			this.lv_checkStatus({
				async insert() {
					await this.lv_save();
					await this.lv_create();
				}
			});
		},
		/**
		 * 启用编辑一行
		 * @author  韦胜健
		 * @date    2019/1/16 14:45
		 */
		async lv_update(rowIndex) {
			if ((!this.option.lv_enable.updateable || this.option.lv_disabled.updateable) && !this.option.customUpdate) return
			Boolean(this.option.beforeEnableUpdate) && await this.option.beforeEnableUpdate.apply(this.option.context, [this.list[rowIndex]]);
			switch (this.option.editType) {
				case 'inline':
					this.baseTable.enableEdit(rowIndex);
					break;
				case 'form':
					const row = this.option.list[rowIndex];
					this.lv_formEdit(row, this.$lv.$utils.deepCopy(row));
					break;
			}
			this.changeStatus(this.EDIT_STATUS.UPDATE)
		},
		/**
		 * 点击删除按钮
		 * @author  韦胜健
		 * @date    2019/1/9 18:01
		 */
		async lv_delete() {
			if (!this.option.lv_enable.deleteable && Boolean(this.option.deleteButton)) return;
			Boolean(this.option.beforeEnableDelete) && await this.option.beforeEnableDelete.call(this.option.context, []);

			const row = this.lv_getRow();
			if (row === null) return;

			!!this.option.beforeDelete && await this.option.beforeDelete.apply(this.option.context, [row])

			this.$dialog.show({
				title: '确认提示',
				message: LinkVue.$t('LinkAutoTable.confirmDeleteRow', {val: this.option.selectIndex + 1 + (this.option.pageData.page - 1) * this.option.pageData.pageSize}),
				confirmButton: true,
				cancelButton: true,
				onConfirm: async () => await this.optionDelete(row)
			});
		},
		async lv_batchInsert() {
			if (this.option.editType !== 'inline') {
				return this.$message.error('只有行内编辑模式下可以启用批量新建功能！')
			}
			const addRowNumber = await new Promise((resolve) => {
				let num = 10;
				const handler = {
					onConfirm: () => {
						if (!num) {
							this.$message.error('输入的行数不正确！')
							return
						}
						resolve(num)
						ins.hide()
					},
					onCancel: () => ins.hide(),
				}
				const ins = this.$dialog.show({
					title: '请输入新建的行数(最大50行)',
					confirmButton: false,
					cancelButton: false,
					height: '55px',
					destroyOnHide: true,
					render: () => <div>
						<link-input-number style="width:100%" v-model={num} max={50} min={2}/>
					</div>,
					footLeftRender: () => <div>
						<link-button onClick={handler.onCancel} type="line">取消</link-button>
						<link-button onClick={handler.onConfirm}>确定</link-button>
					</div>,
				})
			})
			// console.log('addRowNumber', addRowNumber)
			const selectIndex = this.option.selectIndex
			const list = new Array(addRowNumber).fill(0)
			await Promise.all(list.map(() => this.lv_create()))
			this.$nextTick(() => {
				list.forEach((i, index) => this.baseTable.enableEdit(index))
				this.changeSelectRow(selectIndex == null ? 0 : (selectIndex + list.length))
			});
		},
		/**
		 * 点击批量编辑按钮
		 * @author  韦胜健
		 * @date    2019/1/16 10:50
		 */
		async lv_batchUpdate() {
			if (Boolean(this.option.dataChunks) && this.option.dataChunks.length > 0) {
				await this.option._loadDataChunk(true);
			}
			this.baseTable.enableEdit();
			this.changeStatus(this.EDIT_STATUS.UPDATE)
		},
		/**
		 * 表单编辑
		 * @author  韦胜健
		 * @date    2019/3/26 09:47
		 */
		async lv_formEdit(row, editRow) {
			this.$lv.$tableForm.pick({
				row,
				editRow,
				labelWidth: this.option.formEditLabelWidth,
				dialogProps: this.option.formEditDialogProps,
				onConfirm: (newEditRow) => {
					this.lv_checkStatus({
						async insert() {
							await this.optionInsert(row, newEditRow);
							this.newData.splice(0, this.newData.length);
							this.option.list.unshift(row);
							this.$lv.$tableForm.close()
							this.changeStatus(this.EDIT_STATUS.NORMAL)
						},
						async update() {
							await this.optionUpdate(row, newEditRow);
							this.$lv.$tableForm.close()
							this.changeStatus(this.EDIT_STATUS.NORMAL)
						}
					});
				},
				onCancel: () => {
					this.lv_cancel()
				}
			}, this.baseTable.lv_bodyColumns);
		},
		/**
		 * 表单编辑当前选中行
		 * @author  韦胜健
		 * @date    2019/3/28 09:31
		 */
		async lv_openFormEdit() {
			const row = this.lv_getRow();
			Boolean(row) && this.lv_formEdit(row, this.$lv.$utils.deepCopy(row));
			this.changeStatus(this.EDIT_STATUS.UPDATE)
		},

		/*---------------------------------------以下为与选择相关函数-------------------------------------------*/
		/**
		 * 取消选择状态
		 * @author  韦胜健
		 * @date    2019/3/26 11:49
		 */
		async lv_cancelSelect() {
			this.changeStatus(this.EDIT_STATUS.NORMAL)
			if (!this.option.singleSelect) await this.$lv.nextTick();
			this.refreshRender();
			Boolean(this.p_selectData.onCancel) && this.p_selectData.onCancel();
		},
		/**
		 * 确认选择结果
		 * @author  韦胜健
		 * @date    2019/3/26 14:16
		 */
		async lv_confirmSelect() {
			const selectRows = this.$refs.check.getSelectedRows();
			if (selectRows.length === 0) {
				this.$dialog.show('请至少选择一条数据');
				return;
			}
			if (this.p_selectData.autoCancelSelectStatus) this.lv_cancelSelect();
			const tableData = this.$refs.baseTable.p_tableData;

			const selectTableData = selectRows.map((row) => {
				let td = this.$lv.$utils.findOne(tableData, (data) => data.row === row)
				!td && (td = {row, editRow: this.$lv.$utils.deepCopy(row)})
				return td
			});
			Boolean(this.p_selectData.onConfirm) && this.p_selectData.onConfirm(selectTableData);
		},

		/*util*/

		/**
		 * 获取当前选中的行
		 * @author  韦胜健
		 * @date    2019/1/12 11:15
		 */
		lv_getRow() {
			if (this.option.selectIndex == null || !this.option.selectRow) {
				this.$dialog.show({message: '请先选择一条数据！'});
				return null;
			}
			return this.option.list[this.option.selectIndex];
		},

		/**
		 * 筛选标签变化动作监听
		 * @author  韦胜健
		 * @date    2019/1/17 11:25
		 */
		async lv_filterTagChange({combineFiltersRaw}) {
			const {filtersRaw, filterOperator} = combineFiltersRaw
			this.option.combineFilter.filtersRaw = filtersRaw;
			this.option.combineFilter.filterOperator = filterOperator;
			await this.option.reload();
		},
		/**
		 * 在配置表格列信息之前，收集列信息组装表格id
		 * @author  韦胜健
		 * @date    2019/2/21 17:26
		 */
		async p_beforeConfigColumnFunc(columns) {
			this.tableConfig = this.$lv.$tableSetting.getTableConfig(this.option, columns);
			// console.log(this.tableConfig)
			if (Boolean(this.tableConfig)) {
				this.option.title = this.tableConfig.title;
				this.option.searchField = this.tableConfig.searchField;
				this.option.sortField = this.tableConfig.sortField;
				this.option.sortDesc = this.tableConfig.sortDesc;
			}
			this.status !== this.EDIT_STATUS.SELECT && this.lv_initOption();
		},
		/**
		 * 加载个性化配置列数据
		 * @author  韦胜健
		 * @date    2019/2/21 17:06
		 */
		p_configColumnFunc(col, isGroup) {
			if (isGroup) return;
			const tableConfig = this.$lv.$tableSetting.getTableConfig(this.tableConfig.id);
			if (Boolean(tableConfig)) {
				const cols = tableConfig.columns;
				const configCol = this.$lv.$utils.findOne(cols, (item) => item.id === col.id);
				if (Boolean(configCol)) {
					configCol.width -= 0;
					configCol.fit -= 0;
					configCol.order -= 0;
					Object.assign(col, configCol);
					col.settingProps.width = configCol.width;
					col.settingProps.fit = configCol.fit;
				}
			}
		},
		/**
		 * 获取改变的，用来发送请求的requestRow
		 * @author  韦胜健
		 * @date    2019/6/17 20:18
		 */
		pl_getChangeRow(row, editRow) {
			const requestRow = this.$lv.$utils.deepCopy(editRow)
			if (!!this.option.onlyUpdateChangeField) {
				/*强制更新字段*/
				const updateFields = [...new Set(this.alwaysUpdateFields.concat(this.option.forceUpdateFields || []))]
				/*所有字段*/
				const keys = [...new Set(Object.keys(row).concat(Object.keys(requestRow)))]
				/*是否有改变的字段*/
				let hasChange;

				keys.forEach(key => {
					if (requestRow[key] !== row[key]) {
						hasChange = true
					} else {
						if (updateFields.indexOf(key) === -1) {
							delete requestRow[key]
						}
					}
				})
				return hasChange ? requestRow : null

			} else {
				return requestRow
			}
		},
		/**
		 * 清空缓存
		 * @author  韦胜健
		 * @date    2021/6/23 10:24
		 */
		async lv_clearCache() {
			if (!this.option.param) {this.option.param = {}}
			const oldCacheParam = this.option.param.cacheParam
			this.option.param.cacheParam = {flush: 'overall'}
			await this.lv_optionLoad(true)
			if (!oldCacheParam) {
				delete this.option.param.cacheParam
			} else {
				this.option.param.cacheParam = oldCacheParam
			}
		},
		/*business*/

		/**
		 * 插入单挑数据
		 * @author  韦胜健
		 * @date    2019/1/9 17:59
		 */
		async optionInsert(row, editRow) {
			const newRow = await this.option._requestInsert(editRow);
			this.baseTable.saveEdit([{row, editRow, newRow}]);
			this.changeSelectRow(0)
		},
		/**
		 * 批量插入数据
		 * @author  韦胜健
		 * @date    2019/1/10 09:13
		 */
		async optionBatchInsert(editData) {
			const newRows = await this.option._requestBatchInsert(editData.map((item) => item.editRow).reverse());
			this.baseTable.saveEdit(editData.map(({row, editRow}, index) => ({row, editRow, newRow: newRows[index]})));
			this.changeSelectRow(0)
		},
		/**
		 * 更新数据
		 * @author  韦胜健
		 * @date    2019/1/9 18:00
		 */
		async optionUpdate(row, editRow) {
			const requestRow = this.pl_getChangeRow(row, editRow)
			if (!requestRow) {
				this.baseTable.saveEdit([{row, editRow, newRow: {}}]);
			} else {
				const newRow = await this.option._requestUpdate(requestRow);
				// console.log({row, editRow, newRow})
				this.baseTable.saveEdit([{row, editRow, newRow}]);
			}
		},
		/**
		 * 批量更新数据
		 * @author  韦胜健
		 * @date    2019/1/10 14:00
		 */
		async optionBatchUpdate(editData) {
			const changeArray = editData.reduce((ret, item) => {
				const requestRow = this.pl_getChangeRow(item.row, item.editRow)
				if (!!requestRow) {
					ret.push({
						requestRow,
						changeData: item
					})
				}
				return ret
			}, [])

			const requestRows = changeArray.map(item => item.requestRow)
			console.log('requestRows', requestRows)
			const newRows = await this.option._requestBatchUpdate(requestRows);
			this.baseTable.saveEdit(changeArray.map(({changeData: {row, editRow}}, index) => ({row, editRow, newRow: newRows[index]})));
			this.changeSelectRow(0)
		},
		/**
		 * 删除数据
		 * @author  韦胜健
		 * @date    2019/1/9 18:00
		 */
		async optionDelete(row) {
			await this.option._requestDelete(this.list[this.option.selectIndex]);
			let selectIndex = this.option.selectIndex;
			this.list.splice(selectIndex, 1);
			if (selectIndex >= this.option.list.length) {
				selectIndex = this.option.list.length - 1
			}
			if (selectIndex >= 0) {
				this.changeSelectRow(selectIndex)
			} else {
				this.option.prevPage()
			}
		},

		/**
		 * desc 导入
		 * @author huyang
		 * @date 2019/2/22 14:45
		 * @params
		 */
		async importData() {
			let value = '';
			if (this.option.context.pageTabData && this.option.context.pageTabData.path) {
				value += this.option.context.$attrs.path + ','
			}
			if (this.option.importCode) {
				value += this.option.importCode
			}
			if (!value) {
				this.$message.warning('未配置该页面的导入模版，请联系管理员！');
			} else {
				await this.$lv.$import.show(value, this.option.context);
				// await this.option.reload();
			}
			// if (this.option.importCode == null) {
			// 	this.$message.warning('未配置该页面的导入模版，请联系管理员！');
			// } else {
			// 	await this.$lv.$import.show(this.option.importCode, this);
			// 	await this.option.reload();
			// }
		},

		/**
		 * 点击导出按钮
		 * @author  韦胜健
		 * @date    2019/1/12 11:16
		 */
		async exportData() {
			const exportFields = this.renderColumns.map(({field, title, lov}) => ({checked: true, field, name: title, lov})).filter((item) => item.field != null);
			let ret = await this.$lv.$export.show(exportFields);
			const fields = ret.fields;
			const exportsRaw = [];
			for (let i = 0; i < fields.length; i++) {     // 构建导出参数exportsRaw
				const field = fields[i];
				var exportsCol = {
					title: field.name,
					field: field.field,
					order: i
				};
				if (field.lov) {
					// const lovArray = linkLov.getLovArray(field.lov);
					const lovArray = await this.option.context.$lov.getLovByType(field.lov);
					const lovMap = {};
					for (let j = 0; j < lovArray.length; j++) {
						lovMap[lovArray[j].val] = lovArray[j].name;
					}
					exportsCol.lov = field.lov;
					exportsCol.lovMap = lovMap;
				}
				exportsRaw.push(exportsCol);
			}
			const option = {      // 导出数据参数
				exportsRaw: exportsRaw,
				exportCurrentPage: ret.range === 'all' ? 'N' : 'Y',
				exportFileName: ret.fileName,
				exportFileType: ret.fileType
			};
			await this.option._requestExportData(option);
		},

		/**
		 * 点击操作按钮
		 * @author  韦胜健
		 * @date    2019/1/12 11:16
		 */
		handleClickExternalButton(item) {
			let row;
			if (Boolean(item.needRow)) {
				row = this.lv_getRow();
				if (!row) return;
			}
			const next = () => item.handler.apply(this.option.context, [row, this.option.selectIndex]);
			if (Boolean(item.confirm)) {
				this.$dialog.show({
					message: item.confirmLabel || '确认要进行该操作吗？',
					confirmButton: true,
					cancelButton: true,
					onConfirm: next
				});
			} else next();
		},

		/*method*/
		/**
		 * 显示记录计数
		 * @author  韦胜健
		 * @date    2019/1/12 11:17
		 */
		async showCounts() {
			await this.option._requestTotalCount();
			this.$dialog.show({message: LinkVue.$t('LinkAutoTable.currentRecordCounts', {val: this.option.pageData.total}), shadowColor: 'transparent'});
		},
		/**
		 * 显示记录详情
		 * @author  韦胜健
		 * @date    2019/1/12 11:17
		 */
		async showRecordDetail() {
			const row = this.lv_getRow();
			if (row === null) return;
			const {id, createdBy, created, lastUpdatedBy, lastUpdated, rowVersion} = row;
			const param = {ids: [createdBy, lastUpdatedBy]};
			try {
				const {data: {result: [{firstName: creatorName}, {firstName: updaterName}]}} = await this.$http.variable.axios1(`${LinkVue.prefixUrl}/user/queryByIds`, {
					method: 'post',
					data: param,
				});
				this.$dialog.show({
					message: null,
					shadowColor: 'transparent',
					render(h) {
						return (
							<div class="link-auto-table-record-detail">
								<div class="link-auto-table-record-detail-item"><span class="link-auto-table-record-detail-item-left">{LinkVue.$t('LinkAutoTable.recordCode')}：</span><span class="link-auto-table-record-detail-item-right">{id}</span></div>
								<div class="link-auto-table-record-detail-item"><span class="link-auto-table-record-detail-item-left">{LinkVue.$t('LinkAutoTable.createBy')}：</span><span class="link-auto-table-record-detail-item-right">{creatorName}</span></div>
								<div class="link-auto-table-record-detail-item"><span class="link-auto-table-record-detail-item-left">{LinkVue.$t('LinkAutoTable.createAt')}：</span><span class="link-auto-table-record-detail-item-right">{this.$lv.$utils.dateFormat(this.$lv.$utils.dateParse(created, 'YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm')}</span></div>
								<div class="link-auto-table-record-detail-item"><span class="link-auto-table-record-detail-item-left">{LinkVue.$t('LinkAutoTable.updateBy')}：</span><span class="link-auto-table-record-detail-item-right">{updaterName}</span></div>
								<div class="link-auto-table-record-detail-item"><span class="link-auto-table-record-detail-item-left">{LinkVue.$t('LinkAutoTable.updateAt')}：</span><span class="link-auto-table-record-detail-item-right">{this.$lv.$utils.dateFormat(this.$lv.$utils.dateParse(lastUpdated, 'YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm')}</span></div>
								{rowVersion != null && <div class="link-auto-table-record-detail-item"><span class="link-auto-table-record-detail-item-left">{LinkVue.$t('LinkAutoTable.versionNumber')}：</span><span class="link-auto-table-record-detail-item-right">{rowVersion}</span></div>}
							</div>
						);
					}
				});
			} catch (e) {
				console.error(e)
				this.$nav.error('查询失败！' + e)
			}
		},
		/**
		 * 显示记录的历史操作记录
		 * @author  韦胜健
		 * @date    2019/1/30 09:26
		 */
		async showModifyHistory() {
			if (this.option.tableCode == null) return Promise.reject('使用查看修改历史功能时，必须指定option中的tableCode为数据库中的表名');
			const row = this.lv_getRow();
			if (row === null) return;
			this.showRecordHistory(row.id, this.option.tableCode);
		},
		/**
		 * 打开表格设置对话框
		 * @author  韦胜健
		 * @date    2019/2/18 17:25
		 */
		async showTableConfig() {
			await this.$lv.$tableSetting.pick(this);
			this.$refs.baseTable.refreshRender();
			this.changeSelectRow(this.option.selectIndex)
		},
		/**
		 * 加大表格表体高度，显示更多行数据
		 * @author  韦胜健
		 * @date    2019/3/14 18:59
		 */
		async showMoreRows() {
			if (this.option.defaultOptionName !== 'auto-table') return;
			const rowNum = this.option.fillRows || this.option.showNum;
			this.option.fill = false;
			this.option.fillRows = null;
			await this.$lv.nextTick();
			await this.$lv.nextTick();
			const currentPageSize = this.option.pageData.pageSize
			this.option.showNum = (rowNum - 0) * 2;
			// console.log(this.option, currentPageSize, this.option.showNum)
			if (currentPageSize < this.option.showNum) {
				this.option.param.rows = this.option.showNum;
				await this.option.load();
			}
		},
		/**
		 * 批量修改
		 * @author  韦胜健
		 * @date    2019/3/26 19:50
		 */
		async lv_batchModify() {
			/*如果当前处于分块加载数据状态，先把所有数据加载完毕再处理批量修改逻辑*/
			if (Boolean(this.option.dataChunks) && this.option.dataChunks.length > 0) {
				await this.option._loadDataChunk(true);
			}

			this.select({
				autoCancelSelectStatus: false,
				onConfirm: (editData) => {
					/*
					 *   当列拥有以下条件时不可批量修改
					 *   1、disabledBatchModify（禁用批量编辑）为true时
					 *   2、editableFunc动态可编辑不为空
					 *   3、requiredFunc动态必输不为空
					 *   5、editable为false，不可编辑
					 */
					const columns = this.$refs.baseTable.lv_bodyColumns.filter((col) => !(Boolean(col.disabledBatchModify) || Boolean(col.editableFunc) || col.requiredFunc || !col.editable))
						.filter(col => col.colRef().$parent.$options.name !== 'link-table-column-mvg');

					this.$lv.$batchModify.show({
						dialogProps: this.option.batchModifyDialogProps,
						columns,
						onConfirm: async (data) => {
							editData.forEach(({editRow}) => Object.assign(editRow, data));
							await this.optionBatchUpdate(editData);
							this.lv_cancelSelect();
						}
					})
				}
			});
		}
	}
};
</script>

<style lang="scss">

@include themeify {
	$auto-table-inner-padding: 12px;
	.link-auto-table {
		/*height: 100%;*/
		width: 100%;
		box-sizing: border-box;
		color: $auto-table-body-color;


		.link-auto-table-title {
			font-family: $font-family;
			font-size: 14px;
			font-weight: 500;
			color: rgba(0, 0, 0, 0.85);
			letter-spacing: 1px;
			line-height: 16px;
			padding: 12px 16px;
			border-bottom: solid 1px #F0F2F7;
			background-color: white;
		}

		/*---------------------------------------padding start-------------------------------------------*/
		& + .link-auto-table, & + .link-tabs {
			border-top: solid 16px $background;
		}

		.link-auto-table-header, .link-auto-table-filter-tag, .link-auto-table-body, .link-auto-table-footer {
			background-color: white;
			padding: 0 16px;

			&.link-auto-table-header {
				padding-top: 16px;
			}

			&.link-auto-table-footer {
				padding-bottom: 16px;
				padding-top: 16px;
			}
		}

		.lnk-quickfilter {
			padding: 16px 16px;
			position: relative;

			&:after {
				position: absolute;
				bottom: 0;
				left: 16px;
				right: 16px;
				border-bottom: dashed 1px #E9E9E9;
				content: '';
				height: 1px;
			}
		}

		.link-auto-table-filter-form-wrapper {
			.link-form-grid {
				border-bottom: solid 16px $background;
			}
		}

		.link-auto-table-filter-tag, .link-auto-table-header {
			padding-bottom: $auto-table-inner-padding;
		}

		/*---------------------------------------padding end-------------------------------------------*/

		.link-auto-table-header-button-wrapper {
			& > div {
				display: flex;

				.link-button + .link-button {
					margin-left: 8px;
				}

				.link-dropdown {
					margin-left: 8px;
				}
			}
		}

		.link-auto-table-content {
			position: relative;
			box-sizing: border-box;

			.link-auto-table-header {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
			}

			.link-auto-table-footer {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 32px;
				position: relative;

				&:after {
					position: absolute;
					top: 0;
					left: 16px;
					right: 16px;
					height: 1px;
					background-color: $base-table-border-color;
					content: '';
				}

				&.link-auto-table-footer-nodata {
					& > *, &:after {
						pointer-events: none;
						opacity: 0;
					}
				}

				.link-auto-table-page-select {
					line-height: 24px;
				}

				.link-auto-table-footer-total-count-wrapper {
					cursor: pointer;
					font-size: $size-default/2.5;

					.link-auto-table-footer-total-count-num {
						color: $color-primary;
					}
				}
			}
		}

		&.link-auto-table-fill {
			height: 100%;

			.link-auto-table-content {
				/*height: 100%;*/
				display: flex;
				flex-direction: column;

				.link-auto-table-body {
					flex: 1;
					overflow: hidden;

					.lv-base-table {
						height: 100%;
						display: flex;
						flex-direction: column;

						.lv-table-body {
							flex: 1;

							.lv-table-body-item {
								height: 100% !important;
							}
						}
					}

				}
			}
		}
	}

	.link-auto-table-more-button-dropdown {
		.link-dropdown-item {
			text-align: center;
		}
	}

	.link-auto-table-record-detail {
		.link-auto-table-record-detail-item {
			display: flex;
			flex-direction: row;
			font-size: 13px;
			margin-bottom: 6px;

			.link-auto-table-record-detail-item-left {
				width: 120px;
				text-align: right;
				font-weight: bold;
			}

			.link-auto-table-record-detail-item-right {
			}
		}
	}
}
</style>
